import { Controller } from "@hotwired/stimulus"

// The matching-expenses strip (budgets/_match_review). Tapping it opens the
// matching-expenses deck (match_review_deck_controller), which is mounted
// once on the dashboard rather than on every budget panel — the same
// hand-off the bank-review strip makes (bank_review_strip_controller).
export default class extends Controller {
  open() {
    this.dispatch("open", { prefix: "match-review-deck" })
  }
}
